export const SidebarData = [
    {
        title: 'Home',
        path: '/',
        className: 'nav-link'
    },
    {
        title: 'Services',
        path: '/cards',
        className: 'nav-link'
    },
    {
        title: 'About Us',
        path: '/about-us',
        className: 'nav-link'
    },
    {
        title: 'Team',
        path: '/team',
        className: 'nav-link'
    },
    {
        title: 'Info',
        path: '/info',
        className: 'nav-link'
    },
    {
        title: 'Contact',
        path: '/contact',
        className: 'nav-link'
    }
]